<template>
  <b-modal
    v-model="showModal"
    size="lg"
    hide-header
    hide-footer
    @show="modalShown">
    <div class="row align-items-center">
      <template v-if="diff > 0">
        <div class="col">
          La sessione scadrà tra <strong>{{ minutes }}:{{ seconds }}</strong>.
        </div>
        <div class="col-2 text-right">
          <b-button
            variant="primary"
            @click.prevent="renew()">
            Continua
          </b-button>
        </div>
      </template>
      <template v-else>
        <div class="col">
          <strong>Sessione scaduta.</strong>
        </div>
        <div class="col-2 text-right">
          <b-button
            variant="primary"
            :to="{
              name: 'Login',
              query: { redirect: $route.fullPath },
              data: {
                noAlert: true
              }
            }">
            Ok
          </b-button>
        </div>
      </template>
    </div>
  </b-modal>
</template>
<script>
import * as moment from 'moment';
import UserService from 'vue-core/services/UserService';
import HttpInterceptor from 'vue-core/auth/HttpInterceptor';

export default {
  props: {
    // Check every 3 seconds
    interval: {
      type: Number,
      default: 5
    },

    // Notify the user 15 minutes before session expiration
    tolerance: {
      type: Number,
      default: 60 * 15
    }
  },

  data() {
    return {
      diff: 0,
      minutes: 0,
      seconds: 0,
      showModal: false
    };
  },

  created() {
    this.id = setInterval(() => this.checkExpiration(), this.interval * 1000);
  },

  beforeDestroy() {
    clearInterval(this.id);
  },

  methods: {
    checkExpiration() {
      this.diff = HttpInterceptor.secondsToSessionExpiration();
      const duration = moment.duration(this.diff * 1000);
      this.minutes = duration.minutes();
      this.seconds = duration.seconds();

      if (this.diff < 0) {
        clearInterval(this.id);
      } else if (this.diff < this.tolerance) {
        this.showModal = true;
      }
    },

    modalShown() {
      clearInterval(this.id);
      this.id = setInterval(() => this.checkExpiration(), 1000);
    },

    renew() {
      const success = ({ statusCode, data }) => {
        clearInterval(this.id);
        this.id = setInterval(() => this.checkExpiration(), this.interval * 1000);
        this.showModal = false;
      };

      const error = ({ statusCode, data }) => {
        console.error('Ping error', statusCode, data);
      };

      UserService.ping().then(success, error);
    }
  }
};
</script>
